/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const storeCandidateFileDataSchema = z.object({
	file: z.unknown(),
	name: z.string().nullable().optional(),
	sourceEmailId: z.string().uuid().nullable().optional(),
})

export type StoreCandidateFileDataSchema = z.infer<typeof storeCandidateFileDataSchema>
